<template>
  <fusioncharts
      :type="type"
      :width="width"
      :dataformat="dataFormat"
      :dataSource="dataSource"
  />
</template>

<script>
  const dataSource = {
    chart: {
      caption: "График 8 (Грузооборот по культурам)",
      xAxisname: 'Терминалы',
      yAxisname: 'Грузооборот, т',
      theme: "fusion"
    },
    categories: [
      {
        category: [
          { label: "Агрикалчер Кубань" },
          { label: "Зерно-трейд" },
          { label: "Агрикалчер Ростов" }
        ]
      }
    ],
    dataset: [
      {
        seriesname: 'Пшеница 4 класс',
        data: [
          { value: 2222 },
          { value: 42663 },
          { value: 24167 }
        ]
      },
      {
        seriesname: 'Пшеница 5 класс',
        data: [
          { value: 25000 },
          { value: 21000 },
          { value: null }
        ]
      },
      {
        seriesname: 'Ячмень',
        data: [
          { value: 8000 },
          { value: null },
          { value: null }
        ]
      },
      {
        seriesname: 'Пшеница 3 класс',
        data: [
          { value: null },
          { value: 7000 },
          { value: null }
        ]
      },
      {
        seriesname: 'Кукуруза',
        data: [
          { value: null },
          { value: null },
          { value: null }
        ]
      }
    ]
  };

  export default {
    data() {
      return {
        type: "stackedcolumn2d",
        width: 800,
        dataFormat: "json",
        dataSource
      };
    }
  }
</script>

<style scoped>

</style>